import * as React from 'react'
import preval from 'preval.macro'

const BuildDate = preval`module.exports = new Date().toLocaleString();`
// eslint-disable-next-line no-console
console.log(`Build: ${BuildDate}`)

import { ThemeProvider } from '@theme/styled-components'
import Theme from '@theme/Theme'

import MainLayout from '@layout/MainLayout'

import { persist } from '@store/store'

const App = () => {
  const [rehydrated, setRehydrated] = React.useState(false)

  React.useEffect(() => {
    persist().then(() => setRehydrated(true))
  }, [])

  if (!rehydrated) {
    return null
  }

  return (
    <ThemeProvider theme={Theme}>
      <MainLayout />
    </ThemeProvider>
  )
}

export default App
